var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"padding-top":"8rem","padding-bottom":"4rem"}},[_c('PrivacyDE')],1)}
var staticRenderFns = []

export { render, staticRenderFns }